import { ApiError, CreateTrackRecordDto, TrackRecord } from '@36node-fcp/core-sdk';
import { Alert, Form, Input, message, Modal } from 'antd';
import dayjs from 'dayjs';
import styled from 'styled-components';

import { GantryDeviceSelect } from 'src/features/gantry-device';
import { useSession } from 'src/features/session';
import { TrackRecordApiErrorMap } from 'src/features/track-record';
import { useApi } from 'src/lib/react-api';
import { fcp, passFcpApiErrors } from 'src/services';

type EditorValues = CreateTrackRecordDto & {};

interface TrackEditorProps {
  TrackRecord?: TrackRecord;
  onClose: () => void;
  onFinish?: () => void;
}

export const TrackEditor: React.FC<TrackEditorProps> = ({
  TrackRecord,
  onClose: handleClose,
  onFinish: handleFinish,
}) => {
  const onSuccess = () => {
    message.success('创建成功');
    handleClose();
    handleFinish?.();
  };
  const onFailure = (err: ApiError) => {
    const ne = passFcpApiErrors(err, TrackRecordApiErrorMap);
    if (ne.keys) {
      ne.keys.forEach((key) => form.setFields([{ name: key, errors: [ne.message[key]] }]));
    } else {
      message.error(ne.message as string);
    }
  };

  const [form] = Form.useForm<EditorValues>();
  const [createState, create] = useApi(fcp.createTrackRecord, { onSuccess, onFailure });
  const session = useSession();

  const handleOk = () => form.submit();
  const handleSubmit = async (values: EditorValues) => {
    const data = {
      source: '手动添加',
      capAt: values.capAt || dayjs().toISOString(),
      ...values,
      images: values.images ? [values.images] : undefined,
      plateImages: values.plateImages ? [values.plateImages] : undefined,
    };
    if (!data?.ns) {
      data.ns = session?.user?.ns;
    }
    create({ body: { ...data, ns: session?.user?.ns } });
  };

  const isLoading = createState.loading;
  const error = createState.error;

  return (
    <Modal title="新建过车记录" open onOk={handleOk} onCancel={handleClose} confirmLoading={isLoading} width="650px">
      <Container>
        {error && <Alert message={error.message} type="error" />}
        <Form
          name="gantry-device-editor"
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
          initialValues={TrackRecord}
          autoComplete="off"
          onFinish={() => handleSubmit(form.getFieldsValue(true))}
          form={form}
        >
          <Form.Item label="车牌号" name="plate" rules={[{ required: true, message: '请填写车牌' }]}>
            <Input placeholder="填写车牌号" />
          </Form.Item>
          <Form.Item label="号牌种类" name="plateType" rules={[{ required: true, message: '请填写号牌种类' }]}>
            <Input placeholder="填写号牌种类" />
          </Form.Item>
          <Form.Item label="卡口设备" name="gantryDevice" rules={[{ required: true, message: '请选择卡口设备' }]}>
            <GantryDeviceSelect
              placeholder="选择卡口设备"
              onChange={(value, option: any) =>
                form.setFieldsValue({ gantryDevice: value, gantry: option.item.gantry.id, ns: option.item.gantry.ns })
              }
            />
          </Form.Item>
          <Form.Item label="过车图片" name="images">
            <Input placeholder="填写过车图片" />
          </Form.Item>
          <Form.Item label="车辆图片" name="plateImages">
            <Input placeholder="填写车辆图片" />
          </Form.Item>
        </Form>
      </Container>
    </Modal>
  );
};

const Container = styled.div`
  margin: 24px;
`;
